import { SET_SELECTED, SET_INDEX_UPDATE_PREVIEW, SET_VISIBLE_POPUP } from './constats';

export const setPreviewSelected: Function = (selected) => {
    return { 
        type: SET_SELECTED, selected: [...selected] 
    };
}

export const addPreviewSelected: Function = (selected: number[], preview: number) => {
    return { 
        type: SET_SELECTED, 
        selected: [...selected].includes(preview) 
            ? [...selected].filter(item => item !== preview) 
            : [...selected, preview]

    };
}

export const showPreviewEditPopup: Function = (index) => {
    return {
        preview: { type: SET_INDEX_UPDATE_PREVIEW, index: index },
        popup: { type: SET_VISIBLE_POPUP, isVisible: true }
    }
}

